import React from 'react';
import { InPersonLocation } from './InPersonLocation/InPersonLocation';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@eventbrite/marmalade';
import styles from './Location.module.scss';
import { OnlineLocation } from './OnlineLocation/OnlineLocation';
import { ToBeAnnouncedLocation } from './ToBeAnnouncedLocation/ToBeAnnouncedLocation';

export interface Props {
  location: {
    hasAddress: boolean;
    isOnlineEvent?: boolean;
    venueMultilineAddress: string[];
    venueName?: string;
    onlineEventUrl?: string;
  };
  map: {
    location: {
      latitude: number;
      longitude: number;
    };
    gMapsApiKey: string;
    shouldDisplayMap: boolean;
  };
}

export const Location: React.FC<Props> = ({ location, map }) => {
  if (location.isOnlineEvent) {
    return (
      <LocationLayout>
        <OnlineLocation onlineEventUrl={location.onlineEventUrl} />
      </LocationLayout>
    );
  }

  if (!location.hasAddress) {
    return (
      <LocationLayout>
        <ToBeAnnouncedLocation />
      </LocationLayout>
    );
  }

  return (
    <LocationLayout>
      <InPersonLocation
        venueMultilineAddress={location.venueMultilineAddress}
        venueName={location.venueName}
        location={map.location}
        hasMap={map.shouldDisplayMap}
        gMapsApiKey={map.gMapsApiKey}
      />
    </LocationLayout>
  );
};

const LocationLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className={styles.location} id="location">
      <Typography as="h3" variant="heading-sm" className={styles.title}>
        <FormattedMessage id="Location" />
      </Typography>
      {children}
    </div>
  );
};
